import { inject, Injectable } from "@angular/core";
import { ExportRiskEvaluationGQL, ExportRiskEvaluationMutation, GetCptFiltersGQL, GetCptFiltersQuery, GetRiskEvaluationGQL, GetRiskEvaluationQuery, UpdateRiskEvaluationGQL, UpdateRiskEvaluationMutation } from "../../../graphql/generated";
import { map, Observable } from "rxjs";
import { MutationData, unwrapMutationData } from "../shared/graphql-mutation-response.util";
import { convertLazyLoadToComplexWithoutPage } from "./riskmap-risk.service";

@Injectable({
    providedIn: 'root'
})
export class RiskEvaluationService {
    private readonly GetRiskEvaluationGQL: GetRiskEvaluationGQL = inject(GetRiskEvaluationGQL);
    private readonly GetCptFiltersGQL: GetCptFiltersGQL = inject(GetCptFiltersGQL);
    private readonly UpdateRiskEvaluationGQL: UpdateRiskEvaluationGQL = inject(UpdateRiskEvaluationGQL);
    private readonly ExportRiskEvaluationGQL: ExportRiskEvaluationGQL = inject(ExportRiskEvaluationGQL);

    getRiskEvaluation(campaignId: string, riskId: string, valueChain: string, parameters: any, legalEntitiesId: string[]): Observable<GetRiskEvaluationQuery['evaluationRiskViewByCampaignIdAndRiskId']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.GetRiskEvaluationGQL.fetch({ campaignId, riskId, valueChain, query: param.query, sort: param.sort, page: param.page, legalEntitiesId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.evaluationRiskViewByCampaignIdAndRiskId))
    }

    getFilters(valueChain: string): Observable<GetCptFiltersQuery['commonProcessTreeFields']> {
        return this.GetCptFiltersGQL.fetch({ active: true, ids: [], valueChain }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.commonProcessTreeFields))
    }

    udateRiskEvaluation(riskMapId: string, riskId: string, impactId: string, likelihoodId: string, icsId: string, legalEntitiesId: string[]): Observable<MutationData<UpdateRiskEvaluationMutation['updateEvaluationRiskView']>> {
        return this.UpdateRiskEvaluationGQL.mutate({ riskMapId, icsId, impactId, likelihoodId, riskId, legalEntitiesId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.updateEvaluationRiskView), unwrapMutationData('Unable to update the evaluation'))
    }

    exportRiskEvaluation(
        campaignId: string,
        riskId: string,
        valueChain: string,
        timeZone: string,
        parameters: any,
        legalEntitiesId: string[]
    ): Observable<ExportRiskEvaluationMutation['downloadEvaluationRiskView']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.ExportRiskEvaluationGQL.mutate({ campaignId, riskId, valueChain, timeZone, query: param.query, sort: param.sort, legalEntitiesId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.downloadEvaluationRiskView))
    }
}
